import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

export function NotificationPreferences() {
  const [emailAlerts, setEmailAlerts] = useState(true);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Notification Preferences</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <Label htmlFor="email-alerts" className="text-base font-medium">
              Email Alerts
            </Label>
            <p className="text-muted-foreground text-sm">Receive email notifications for property status changes.</p>
          </div>
          <Switch id="email-alerts" checked={emailAlerts} onCheckedChange={setEmailAlerts} />
        </div>
      </CardContent>
    </Card>
  );
}
